export default "/images/2c8eaf264186df085b3fc89782f61e03.avif";